import React, { Component } from 'react';
import {connect} from 'react-redux';
import PaymentRequest from '../../components/PaymentRequest';
import PaypalPayment from '../../components/PaymentRequest/paypal';
import GiftCouponOnlinePayment from '../../components/PaymentRequest/giftCouponOnline'
import AssignGiftcouponView from '../../components/PaymentRequest/assignGiftcouponView';
import {fetchpaymentUsers, fetchpaymentDataByUserID, verifyPaypalTranaction, rejectPaypalTransaction,
        checkPaypalPayment, paypalPaymentPayToUser, stopVerifyMessage, fetchGiftCouponOnlinePaymentDataByUserID,
        verifyGiftCouponOnlineTransaction, rejectGiftCouponOnlineTransaction, stopGiftCouponOnlineVerifyMessage,
        giftCouponOnlinePaymentPayUser, getCouponsToAsigntoUserByAdmin
      } from '../../actions/payment';
class Payment extends Component {
  constructor(props){
    super(props)
    this.state = {
      paymentReviewData : {}
    }
    this.paymentReview = this.paymentReview.bind(this); 
    this.showPaymentRequest = this.showPaymentRequest.bind(this);
    this.verifyPaypal = this.verifyPaypal.bind(this);
    this.rejectPaypal = this.rejectPaypal.bind(this);
    this.paypalPaymentPayUser = this.paypalPaymentPayUser.bind(this);
    this.stopVerifyMessage = this.stopVerifyMessage.bind(this);
    this.checkPaypalPayment = this.checkPaypalPayment.bind(this);
    this.openAddCouponView = this.openAddCouponView.bind(this);
  
    this.reviewGiftCouponPayment = this.reviewGiftCouponPayment.bind(this);
    this.verifyGiftCouponOnline = this.verifyGiftCouponOnline.bind(this);
    this.rejectGiftCouponOnline = this.rejectGiftCouponOnline.bind(this);
    this.stopGiftCouponOnlineVerifyMessage = this.stopGiftCouponOnlineVerifyMessage.bind(this);
    this.giftCouponOnlinePaymentPayUser = this.giftCouponOnlinePaymentPayUser.bind(this);
    this.getCouponsToAsigntoUserByAdmin = this.getCouponsToAsigntoUserByAdmin.bind(this);
  }

  componentWillMount() {
    
    let token=sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchpaymentUsers(token));
  }

  checkPaypalPayment(data){
    let datas={};
    let token=sessionStorage.getItem("adminToken");
    datas.payaplTxnData = data;
    datas.token = token
   
    this.props.dispatch(checkPaypalPayment(datas));
  }
 
  showPaymentRequest(){
    let token=sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchpaymentUsers(token));
  }

    
  paymentReview(data){
    //this.setState({paymentReviewData : data });
   
    let token = sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchpaymentDataByUserID(data._id, token));
  }

  reviewGiftCouponPayment(data){
    let token = sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchGiftCouponOnlinePaymentDataByUserID(data._id, token));
  }
    
  verifyPaypal(data){
    this.props.dispatch(verifyPaypalTranaction(data));
  }

  rejectPaypal(data){
    this.props.dispatch(rejectPaypalTransaction(data));
  }

  paypalPaymentPayUser(data){
    this.props.dispatch(paypalPaymentPayToUser(data));
  }

  stopVerifyMessage(){
    this.props.dispatch(stopVerifyMessage());
  }

  openAddCouponView(){
    this.props.history.push('/coupon');
  }


  //giftCouponOnline

  verifyGiftCouponOnline(data){
    this.props.dispatch(verifyGiftCouponOnlineTransaction(data));
  }

  rejectGiftCouponOnline(data){
    this.props.dispatch(rejectGiftCouponOnlineTransaction(data));
  }

  stopGiftCouponOnlineVerifyMessage(){
    this.props.dispatch(stopGiftCouponOnlineVerifyMessage());
  }

  giftCouponOnlinePaymentPayUser(data){
    this.props.dispatch(giftCouponOnlinePaymentPayUser(data));
  }

  getCouponsToAsigntoUserByAdmin(){
    let token=sessionStorage.getItem("adminToken");
    this.props.dispatch(getCouponsToAsigntoUserByAdmin(token));
  }

  render() {

    if(!this.props.authenticated){
         let adminToken=sessionStorage.getItem("adminToken");
          if(adminToken){
        //   this.props.dispatch(fetchStudy(userId, access_token));
         }else {
           alert("Please login.");
           this.props.history.push("login");
         }
  }
  let paymentRequestView ="";

 
    if(this.props.showPaymentView){
      paymentRequestView = <div className = "paymentlist">
      <div className = "paymentlistbackground">
            <div className = "usertable"><h1>Payment Requests</h1>
            </div>          
          <PaymentRequest
            paymentReqList = {this.props.paymentReqList}
            paymentReqListSuccess = {this.props.paymentReqListSuccess}
            paymentReview ={this.paymentReview}
            reviewGiftCouponPayment = {this.reviewGiftCouponPayment}
            checkPaypalPayment = {this.checkPaypalPayment}
            /></div></div>
   }else if(this.props.showPaypalPaymentProcess){
    paymentRequestView = <PaypalPayment
            userTransactionData = {this.props.userTransactionData}
            userTransactionSuccess = {this.props.userTransactionSuccess}
            showPaymentRequest = {this.showPaymentRequest}
            verifyPaypal = {this.verifyPaypal}
            rejectPaypal = {this.rejectPaypal}
            verifySuccess = {this.props.verifySuccess}
            verifymessage = {this.props.verifymessage}
            rejectSuccess = {this.props.rejectSuccess}
            rejectmessage = {this.props.rejectmessage}
            paypalPaymentPayUser = {this.paypalPaymentPayUser}
            userPaySuccess = {this.props.userPaySuccess}
            userPayData = {this.props.userPayData}
            requestStarted = {this.props.requestStarted}
            stopVerifyMessage = {this.stopVerifyMessage}
            resCheckPalPalPaymentData = {this.props.resCheckPalPalPaymentData}
            resCheckPalPalPaymentStatus = {this.props.resCheckPalPalPaymentStatus}
            />
   }else if(this.props.showGiftCouponOnlinePayment){
    paymentRequestView =  <GiftCouponOnlinePayment
        userGiftcouponOnlineTransactionData = {this.props.userGiftcouponOnlineTransactionData}
        userGiftcouponOnlineTransactionSuccess = {this.props.userGiftcouponOnlineTransactionSuccess}
        showPaymentRequest = {this.showPaymentRequest}
        verifyGiftCouponOnline = {this.verifyGiftCouponOnline}
        rejectGiftCouponOnline = {this.rejectGiftCouponOnline}
        giftCouponOnlineVerifySuccess = {this.props.giftCouponOnlineVerifySuccess}
        giftCouponOnlineVerifymessage = {this.props.giftCouponOnlineVerifymessage}
        giftCouponRejectSuccess = {this.props.giftCouponRejectSuccess}
        giftCouponRejectmessage = {this.props.giftCouponRejectmessage}
        stopGiftCouponOnlineVerifyMessage = {this.stopGiftCouponOnlineVerifyMessage}
        getCouponsToAsigntoUserByAdmin = {this.getCouponsToAsigntoUserByAdmin}    
        showGiftCouponCountPaymentView = {this.props.showGiftCouponCountPaymentView}
      />
   }else if(this.props.showGiftCouponCountPaymentView){
    paymentRequestView = <AssignGiftcouponView
      showPaymentRequest = {this.showPaymentRequest}
      userGiftcouponOnlineTransactionData = {this.props.userGiftcouponOnlineTransactionData}
      userGiftcouponOnlineTransactionSuccess = {this.props.userGiftcouponOnlineTransactionSuccess}
      giftcouponCountSuccess = {this.props.giftcouponCountSuccess}
      giftcouponCountData = {this.props.giftcouponCountData}
      giftCouponOnlinePaymentPayUser = {this.giftCouponOnlinePaymentPayUser}
      giftcouponPaymentSuccess = {this.props.giftcouponPaymentSuccess}
      giftcouponPaymentData = {this.props.giftcouponPaymentData}
        />
   }


   return (<div>
            {paymentRequestView}
          </div>
   );
  }
}

const  mapStateToProps =(state) =>{
  return {
    authenticated : state.login.authenticated,
    paymentReqList : state.payment.paymentReqList,
    paymentReqListSuccess : state.payment.paymentReqListSuccess,
    showPaymentView : state.payment.showPaymentView,
    showPaypalPaymentProcess : state.payment.showPaypalPaymentProcess,
    userTransactionData : state.payment.userTransactionData,
    userTransactionSuccess : state.payment.userTransactionSuccess,
    verifySuccess : state.payment.verifySuccess,
    verifymessage : state.payment.verifymessage,
    rejectSuccess : state.payment.rejectSuccess,
    rejectmessage : state.payment.rejectmessage,
    userPayData : state.payment.userPayData,
    userPaySuccess : state.payment.userPaySuccess,
    requestStarted : state.common.requestStarted,
    resCheckPalPalPaymentStatus : state.payment.resCheckPalPalPaymentStatus,
    resCheckPalPalPaymentData : state.payment.resCheckPalPalPaymentData,
    //giftCoupon
    showGiftCouponOnlinePayment : state.payment.showGiftCouponOnlinePayment,
    userGiftcouponOnlineTransactionData : state.payment.userGiftcouponOnlineTransactionData,
    userGiftcouponOnlineTransactionSuccess : state.payment.userGiftcouponOnlineTransactionSuccess,
    giftCouponOnlineVerifySuccess : state.payment.giftCouponOnlineVerifySuccess,
    giftCouponOnlineVerifymessage : state.payment.giftCouponOnlineVerifymessage,
    giftCouponRejectSuccess : state.payment.giftCouponRejectSuccess,
    giftCouponRejectmessage :  state.payment.giftCouponRejectmessage,
    giftcouponCountSuccess : state.payment.giftcouponCountSuccess,
    giftcouponCountData : state.payment.giftcouponCountData,
    showGiftCouponCountPaymentView : state.payment.showGiftCouponCountPaymentView,
    giftcouponPaymentSuccess : state.payment.giftcouponPaymentSuccess,
    giftcouponPaymentData : state.payment.giftcouponPaymentData
  }
}

export default connect(mapStateToProps)(Payment);



// WEBPACK FOOTER //
// ./src/pages/Payment/index.js